import { render } from "./Disclaimer.vue?vue&type=template&id=b63ba3d4"
import script from "./Disclaimer.vue?vue&type=script&lang=js"
export * from "./Disclaimer.vue?vue&type=script&lang=js"

import "./Disclaimer.vue?vue&type=style&index=0&id=b63ba3d4&lang=scss"

import exportComponent from "/opt/build/repo/access-trucks/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__